import React from 'react'
import useCurrentUser from '../../../hooks/use-current-user'
import useClientLocation from '../../../hooks/use-client-location'
import EditModal from '../edit-modal'
import useReflectionPrompt from './use-reflection-prompt'
import BusyModal from '../../modals/busy'

const ReflectionPromptScreen = () => {

    const { isAdmin } = useCurrentUser()
    const { goBack, params } = useClientLocation()
    const id = params.reflectionPromptId !== 'new' ? params.reflectionPromptId : undefined
    const { isLoadingReflectionPrompt, reflectionPrompt } = useReflectionPrompt({ id })

    if (!isAdmin) {
        return null
    }

    if (isLoadingReflectionPrompt) {
        return (<BusyModal title='Loading Reflection Prompt' />)
    }

    return (
        <EditModal
            onHide={goBack}
            reflectionPrompt={reflectionPrompt}
        />
    )
}

export default ReflectionPromptScreen